import { CodeBlockIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const CodeBlock = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <CodeBlockIcon size={Sizes[size]} color={fill} {...rest} />;
};

CodeBlock.displayName = 'CodeBlock';
